import {observable, action} from 'mobx'
import {api, updateHeaders} from 'helpers/Api'
import {ICrudStore} from 'Store'
import {User} from './Model'
import Storage from 'helpers/Storage'
import {Role} from './Model'
import {t} from 'helpers/i18n'
import {store} from 'App'

export default class implements ICrudStore<User> {
  @observable users: User[] = []
  @observable user: User
  @observable loaded: boolean = false

  constructor() {
    this.rehydrate()
  }

  login = (payload: {client: string; username: string; password: string}) => {
    return api.post('login', payload).then(response => {
      if (response.role !== Role.Seller) {
        Storage.set(USER_KEY, JSON.stringify(response))
        this.user = new User(response)
        updateHeaders(response.token, response.client)
      } else {
        store.UI.newError(t('error:userNoAccess'))
      }
    })
  }

  logout = async () => {
    Storage.remove(USER_KEY)
    api.post('logout/' + this.user.id)
    window.location.reload()
  }

  recovery = (payload: {client: string; email: string}) => {
    return api.post('user/recovery', payload).then()
  }

  rehydrate() {
    let user = Storage.getJSON(USER_KEY)
    if (user) {
      this.user = new User(user)
      updateHeaders(user.token, user.client)
    }
  }

  read(id?: number): any /* tslint:disable-line:no-any */ {
    if (id) return api.get('user/' + id).then(user => new User(user))
    return api.get(USER_KEY).then(this.set)
  }

  create(user: User) {
    return api.post('user', user).then(this.push)
  }

  update(id: number, user: User) {
    return api.put('user/' + id, user).then(this.replace)
  }

  disable(id: number, disabled: boolean) {
    return api.patch('user/' + id, {disabled}).then(this.pull)
  }

  fingById = (id: number) => {
    return this.users.filter(value => value.id === id)[0]
  }

  @action
  private set = (users: User[]) => {
    this.users = users.map(user => new User(user))
    this.loaded = true
  };

  @action
  private push = (user: User) => {
    this.users.push(new User(user))
  }

  @action
  private replace = (user: User) => {
    this.users.splice(this.users.findIndex(f => f.id === user.id), 1, user)
  }

  @action
  private pull = (user: User) => {
    this.users.splice(this.users.findIndex(a => a.id === user.id), 1)
  }
}
export const USER_KEY = 'user'



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Users/Store.ts